const unavailableSymbol3DAssetUrls = new Set<string>();
const unavailableUserModel3DIds = new Set<string>();

type AssetAvailabilityReference = {
  source?: string;
  id?: string;
  url?: string;
};

export function markSymbol3DAssetUnavailable(
  asset: AssetAvailabilityReference,
) {
  if (asset.url) {
    unavailableSymbol3DAssetUrls.add(asset.url);
  }
  if (asset.source === "userModel" && asset.id) {
    unavailableUserModel3DIds.add(asset.id);
  }
}

export function markUserModel3DUnavailable(modelId: string) {
  unavailableUserModel3DIds.add(modelId);
}

export function isSymbol3DAssetUnavailable(
  asset: AssetAvailabilityReference,
): boolean {
  if (asset.url && unavailableSymbol3DAssetUrls.has(asset.url)) {
    return true;
  }
  return Boolean(
    asset.source === "userModel" &&
      asset.id &&
      unavailableUserModel3DIds.has(asset.id),
  );
}

export function isMissingSymbol3DAssetLoadError(error: unknown): boolean {
  const message = getErrorMessage(error);
  if (/\b404\b/i.test(message) || /not found/i.test(message)) {
    return true;
  }

  const status = getErrorStatus(error);
  return status === 404;
}

export function clearSymbol3DAssetAvailabilityForTests() {
  unavailableSymbol3DAssetUrls.clear();
  unavailableUserModel3DIds.clear();
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  return "";
}

function getErrorStatus(error: unknown): number | undefined {
  const maybeEvent = error as {
    target?: { status?: unknown };
    currentTarget?: { status?: unknown };
    status?: unknown;
  };
  const status =
    maybeEvent.status ??
    maybeEvent.target?.status ??
    maybeEvent.currentTarget?.status;
  return typeof status === "number" ? status : undefined;
}
